module.exports = require('./helpers/bundle-url').getBundleURL('c00bE') + "logo.c51670a8.svg";